export enum DocumentStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Declined = 'Declined',
}
